import { graphql } from 'react-relay';

export const saveApplyRefundDelegationFiles = graphql`
  mutation saveApplyRefundDelegationFilesMutation($signedAt: String!, $autographImage: String!, $delegationDocumentFile: String!, $refundId: String!) {
    saveApplyRefundDelegationFiles(signedAt: $signedAt, autographImage: $autographImage, delegationDocumentFile: $delegationDocumentFile, refundId: $refundId) {
      result
      errors {
        code
      }
      autographImageKey
      delegationFileKey
    }
  }
`;
